export default __webpack_public_path__ + "static/media/ukflag.2e10aa0b.ico";